module.exports = __webpack_public_path__ + "img/icon1.55e81ffd.png";